import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { CompetenciesRouter } from '../../../competencies/types';
import { modules } from '../../modules';

@injectable()
export class CompetenciesRouterService implements CompetenciesRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.competencies.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.competencies.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToDetail(id: string) {
    this.history.push(`/${this.role.get()}/${modules.events.basename}/${id}`);
  }
}
